import React from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";

const Accessibility = () => {
  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle=" إمكانية الوصول "
            title=" الرئيسية"
            subtitle=" إمكانية الوصول"
          />
          <div className="small-container">
            <div className="card flex-fill accessibility-statement ">
              <div className="inner-header text-center text-primary card-header p-3">
                <h1>بيان إمكانية الوصول</h1>
              </div>
              <div className="card-body">
                <div className="inner-content text-right account-wrapper login-black content ">
                  <p>
                    تبذل Fintrack قصارى جهدها وتستثمر العديد من الموارد من أجل
                    تزويد جميع عملائها بالموقع والمنصة بطريقة محترمة وسهلة
                    الوصول ومهنية. وفقًا لقانون المساواة في الحقوق للأشخاص ذوي
                    الإعاقة 1998 واللوائح الموضوعة بموجبه، يتم استثمار العديد من
                    الجهود والموارد في إجراء التعديلات اللازمة لإمكانية الوصول
                    والتي ستؤدي إلى قدرة الشخص المعاق على تنفيذ الإجراءات على
                    النظام الأساسي والموقع الإلكتروني بشكل مستقل ومتساوٍ.
                  </p>
                  <div className="card-header pt-0">
                    <h3 className="text-primary card-title">
                      خدمة عملاء يمكن الوصول إليها
                    </h3>
                  </div>
                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      <p>
                        تدريبات الموظفين على الخدمة التي يمكن الوصول إليها - يتم
                        إجراء التدريبات لتعريف مجال الوصول، وخلق الوعي بين
                        الموظفين وتوفير أدوات عملية لتقديم خدمة يمكن الوصول
                        إليها.
                      </p>
                    </li>
                    <li>
                      <p>
                        دعم يمكن الوصول إليه - يمكنك الاتصال بنا كتابيًا عبر
                        البريد الإلكتروني{" "}
                        <a href="mailto:support@massarwe.com">
                          support@massarwe.com
                        </a>{" "}
                        أو رسالة خاصة على صفحتنا على Facebook. بالنسبة للأشخاص
                        ذوي الإعاقة، نقدم أيضًا الدعم عبر الهاتف - اتصل بنا
                        كتابيًا باستخدام رقم الهاتف وسنعاود الاتصال بك.
                      </p>
                    </li>
                  </ul>

                  <div className="card-header pt-0">
                    <h3 className="text-primary card-title">
                      الوصول إلى الموقع
                    </h3>
                  </div>
                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      <p>
                        موقع الويب الذي يمكن الوصول إليه هو موقع ويب يسمح
                        للأشخاص ذوي الإعاقة وكبار السن بالتصفح بنفس مستوى
                        الكفاءة والمتعة مثل جميع متصفحي الإنترنت الآخرين. يواجه
                        حوالي 20 إلى 25 بالمائة من السكان صعوبات في استخدام
                        الإنترنت وقد يستفيدون من محتوى الإنترنت الذي يمكن الوصول
                        إليه بشكل أكبر.
                      </p>
                    </li>
                    <li>
                      <p>
                        تؤمن Fintrack وتعمل من أجل تكافؤ الفرص في مساحة الإنترنت
                        للأشخاص ذوي الإعاقات المختلفة والأشخاص الذين يستخدمون
                        التكنولوجيا المساعدة لاستخدام الكمبيوتر.
                      </p>
                    </li>
                  </ul>

                  <div className="card-header pt-0">
                    <h3 className="text-primary card-title">
                      معلومات حول الوصول إلى موقع الويب
                    </h3>
                  </div>

                  <ul className="text-primary-ol list-disc p-3 pt-0">
                    <li>
                      يتوافق هذا الموقع مع متطلبات اللوائح المتعلقة بالمساواة في
                      الحقوق للأشخاص ذوي الإعاقة (تعديلات إمكانية الوصول إلى
                      الخدمة)، 2013.
                    </li>
                    <li>
                      تم إجراء تعديلات إمكانية الوصول وفقًا لتوصيات المعيار
                      الإسرائيلي (TI 5568) لإمكانية الوصول إلى المحتوى على
                      الإنترنت على مستوى AA ووثيقة WCAG2.0 الدولية.
                    </li>
                    <li>تم اختبار الموقع لمتصفح Chrome لتحقيق أفضل توافق.</li>
                    <li>
                      يوفر الموقع بنية دلالية للتقنيات المساعدة ودعمًا لاستخدام
                      لوحة المفاتيح (الأسهم، Enter، Esc).
                    </li>
                    <li>
                      مُكيَّف للعرض في المتصفحات الشائعة وللاستخدام على الهاتف
                      المحمول.
                    </li>
                    <li>
                      تم إجراء الاستشارات بواسطة شركة MASSUX للتسويق عبر
                      الإنترنت وإمكانية الوصول.
                    </li>
                  </ul>
                  <div className="card-header pt-0">
                    <h3 className="text-primary card-title">
                      بناء ترتيبات الوصول والتواصل معنا
                    </h3>
                  </div>

                  <p>
                    يمكنك التواصل معنا من خلال القنوات الرقمية. إذا واجهت مشكلة
                    أو عطلًا فيما يتعلق بإمكانية الوصول، سنكون ممتنين لو أبلغتنا
                    بذلك وسنبذل قصارى جهدنا لإيجاد حل مناسب ومعالجة هذا الخلل في
                    أقرب وقت ممكن.
                  </p>
                  <p>
                    يمكنك الاتصال بنا بخصوص مشكلات الوصول عبر{" "}
                    <strong>نموذج الاتصال</strong> في الموقع.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
    </>
  );
};
export default Accessibility;
